module.exports = __webpack_public_path__ + "img/delete.cdee674c.svg";